/* eslint-disable quotes */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { ISaleDocument } from '../sales-notes.interface';
import { SaleNoteDocumentService } from '../sales-notes.service';
import { SaleNoteCancelDocumentService } from '../sales-notes-cancel.service';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-sale-note-document',
  templateUrl: './sale-note-document.component.html'
})
export class SaleNoteDocumentComponent extends TableActionsTemplate {
  idDocument: number;
  openCancellationDialog = false;
  confirmSettings = {};
  saleNoteToCancel: any;
  showOpenGroupedSaleNote = false;
  constructor(
    private serviceBase: SaleNoteDocumentService,
    private serviceBaseCancel: SaleNoteCancelDocumentService
  ) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Notas de Venta Pendientes',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Punto Venta', field: 'pointSaleCode' },
        { header: 'Cliente', field: 'clientName' },
        { header: 'N° Documento', field: 'numberDocument' },
        { header: 'Comprobante', field: 'typeVoucher' },
        {
          header: 'Tipo Pago',
          field: 'methodPayment',
          tag: 'tagPaymentMethod'
        },
        { header: 'Monto', field: 'amount', pipe: 'Currency' },
        { header: 'Fecha Creación.', field: 'createdAt', pipe: 'Date' },
        { header: 'Vendedor', field: 'userUsername' },
        { header: 'Estado', field: 'statusSale', tag: 'tagStatus' }
      ]
    };
    this.table.actionsHead = [
      {
        name: 'grouped-sales-note',
        icon: 'pi pi-book',
        class: 'p-button-rounded p-button-warning',
        pTooltip: 'Agrupar Notas de Ventas'
      }
    ];
    this.table.actions = [
      {
        name: 'detail',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'remove',
        icon: 'pi pi-times',
        class: 'p-button-rounded p-button-danger',
        pTooltip: 'Anular'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: ISaleDocument[]) => {
        data = data.map((item) => {
          item.tagPaymentMethodColor = getTagColor(item.methodPayment);
          item.tagStatusColor = getTagColor(item.statusSale);
          return item;
        });
        this.table.data = data;
      });
  }

  onReciveAction(event: IEventAction): void {
    if (event) {
      const { action, data } = event;
      if (action === 'remove') {
        this.openCancellationDialog = true;
        this.saleNoteToCancel = data;
      } else if (action === 'detail') {
        this.idDocument = data['id'];
      }
    }
  }

  onReciveActionHead(event: IEventAction): void {
    if (event) {
      const { action } = event;
      if (action === 'grouped-sales-note') {
        // this.confirmSettings = {
        //   message: 'AGRUPAR',
        //   action: 'grouped-sales-note'
        // };
        this.showOpenGroupedSaleNote = true;
      }
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;
    if (action === 'remove') {
      const { id } = data;
      this.message = { message: 'Anulando Nota de Venta' };
      this.message = await this.serviceBaseCancel.update(id, null);
    }
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
